import axios from 'axios';

const api = axios.create({ baseURL: '/api', timeout: 30000 });

export const searchStocks = (q) => api.get('/stocks/search', { params: { q } }).then(r => r.data);
export const getFullData = (symbol) => api.get(`/stocks/${symbol}/full`).then(r => r.data);
export const getValuation = (symbol, assumptions = {}) => {
  const { adamKhoo, ...rest } = assumptions;
  const params = { ...rest };
  if (adamKhoo) {
    params.ak_g1 = adamKhoo.growthRate1_5;
    params.ak_g2 = adamKhoo.growthRate6_10;
    params.ak_g3 = adamKhoo.growthRate11_20;
    params.ak_dr = adamKhoo.discountRate;
  }
  return api.get(`/stocks/${symbol}/valuation`, { params }).then(r => r.data);
};
export const getWatchlistQuotes = (symbols) => api.post('/watchlist/quotes', { symbols }).then(r => r.data);
export const getTechnicals = (symbol, period) => api.get(`/stocks/${symbol}/technicals`, { params: { period } }).then(r => r.data);
export const getTechnicalsMore = (symbol, period, before) => api.get(`/stocks/${symbol}/technicals/more`, { params: { period, before } }).then(r => r.data);
export const getHoldings = (symbol) => api.get(`/stocks/${symbol}/holdings`).then(r => r.data);
export const getDividends = (symbol) => api.get(`/stocks/${symbol}/dividends`).then(r => r.data);
export const getAIInsight = (symbol) => api.post('/ai/insight', { symbol }).then(r => r.data);
export const getMarketMovers = () => api.get('/market/movers').then(r => r.data);
export const getWatchlistMovers = (symbols) => api.get('/market/watchlist-movers', { params: { symbols: symbols.join(',') } }).then(r => r.data);
export const getWhyMoving = (symbol, name, changePercent, lang) => api.post('/market/whymoving', { symbol, name, changePercent, lang }).then(r => r.data);
export const getUpcomingEvents = (symbols) => api.get('/market/events', { params: { symbols: symbols.join(',') } }).then(r => r.data);
export const getMarketIndices = () => api.get('/market/indices').then(r => r.data);

export default api;
